import type { GameStatus } from '@ottd/api';
import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

/*
 * The game-lifecycle chip next to the prototype's "● LIVE" badge: same pixel
 * chip, recoloured per state so a finished or cancelled game can't be mistaken
 * for one still running.
 */
const STATE: Record<GameStatus, { mark: string; className: string }> = {
  live: { mark: '●', className: 'border-[#3d5c2e] text-[#8ed065]' },
  ended: { mark: '★', className: 'border-[#6b5a1e] text-[#ffd34d]' },
  cancelled: { mark: '✕', className: 'border-[#6b2e2e] text-[#e07070]' },
};

type Props = {
  status: GameStatus;
  className?: string;
};

export function GameStatusBadge({ status, className }: Props) {
  const { t } = useTranslation('common');
  const state = STATE[status];
  return (
    <span
      className={cn(
        'font-display inline-flex items-center gap-1 border bg-[#14161a] px-1.5 py-0.5 text-[9px] uppercase tracking-wide',
        state.className,
        className,
      )}
    >
      <span aria-hidden>{state.mark}</span> {t(`status.${status}`)}
    </span>
  );
}
